import { Injectable } from '@angular/core';
import { BrowserStack } from 'protractor/built/driverProviders';

@Injectable()
export class SortTableService {
  sortDetails = {
    allSuggestionListSort: {
      field: 'department',
      sortType: 'ascending',
    },
    allReviewSLList: {
      field: 'department',
      sortType: 'ascending',
    },
    myDraftsList: {
      field: 'department',
      sortType: 'ascending',
    },
    mySLList: {
      field: 'department',
      sortType: 'ascending',
    },
    allGroupList: {
      field: 'title',
      sortType: 'ascending',
    },
    myGroupList: {
      field: 'title',
      sortType: 'ascending'
    }
  };

  constructor() { }

  sortedTable(tableName, field) {
    this.sortDetails[tableName].field = field;
    return this.sortDetails[tableName].sortType === 'descending' ? 'ascending' : 'descending';
  }

  sortList = (tableName, list, field, sortType= null) => {
    if (sortType) {
      this.sortDetails[tableName].sortType = this.sortedTable(tableName, field);
    }
    switch (this.sortDetails[tableName].field) {
      case ('department'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => a.group.name.localeCompare(b.group.name)) :
          list.sort((a, b) => b.group.name.localeCompare(a.group.name));
        break;
      case ('type'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => a.description.localeCompare(b.description)) :
          list.sort((a, b) => b.description.localeCompare(a.description));
          break;
      case ('status'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => a.status.localeCompare(b.status)) :
          list.sort((a, b) => b.status.localeCompare(a.status));
        break;
      case ('title'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => a.name.localeCompare(b.name)) :
          list.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case ('date'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => a.creationDate.localeCompare(b.creationDate)) :
          list.sort((a, b) => b.creationDate.localeCompare(a.creationDate));
      break;
      case ('initiator'):
          this.sortDetails[tableName].sortType === 'descending' ? 
          list.sort((a, b) => a.initiator.fullName.localeCompare(b.initiator.fullName)) :
          list.sort((a, b) => b.initiator.fullName.localeCompare(a.initiator.fullName));
      break;
      case ('levels'):
        this.sortDetails[tableName].sortType === 'descending' ? 
        list.sort((a, b) => b.data.level.localeCompare(a.data.level)): 
        list.sort((a, b) => a.data.level.localeCompare(b.data.level));
      break;
    case ('dates'):
        this.sortDetails[tableName].sortType === 'descending' ?
        list.sort((a, b) => b.data.date.localeCompare(a.data.date)): 
        list.sort((a, b) => a.data.date.localeCompare(b.data.date));
      
        break;
    }
  }
}





// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/sort-table.service.ts